import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DonationResponseDto, DonationService, FamilyService, ListService, NoteService } from 'src/app/backend';
import { BasePagedComponent } from 'src/app/core/components/base-paged/base-paged.component';
import { FamilyResponseDto } from '../../../backend/model/familyResponseDto';
import { UserRoleEnum } from '../../../backend/model/userRoleEnum';
import { DialogRef } from '../../../core/dialog/dialog-ref';
import { DialogConfig, DialogService } from '../../../core/dialog/dialog.service';
import { AuthService } from '../../../core/services/auth.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { SaveNoteDialogComponent } from '../save-note-dialog/save-note-dialog.component';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import moment from 'moment';

interface UserRow {
  id: number;
  representative: string;
  phone: string;
  address: string;
  city: string;
  lastDonationOdjeca: any;
  documents: boolean;
}

@Component({
  templateUrl: './save-list-dialog.component.html',
  //   styleUrls: ['./save-user-dialog.component.scss'],
})
export class SaveListDialogComponent
  extends BasePagedComponent
  implements OnInit
{
  UserRole = UserRoleEnum;
  data: UserRow[] = [];
  donations: DonationResponseDto[] = [];
  form = new UntypedFormGroup({});
  id = 0;
  isLoading = false;
  isSaving = false;
  isLocked = false;
  setOfCheckedId = new Set<number>();
  searchQueryControl = new UntypedFormControl('');

  constructor(
    private dialogConfig: DialogConfig,
    private dialogService: DialogService,
    private dialogRef: DialogRef,
    private t: TranslateService,
    private listService: ListService,
    private donationService: DonationService,
    private familyService: FamilyService,
    authService: AuthService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
    const config = this.dialogConfig;
    this.id = config.data?.id;

    this.form = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required]),
      date: new UntypedFormControl(''),
      locked: new UntypedFormControl(''),
    });

    if (this.id) {
      this.loadList(this.id);
    }
  }

  ngOnInit() {
    if (!this.id) {
      this.loadFamilyData();
      //  this.loadData();
    }
  }

  loadList(id: number) {
    this.isLoading = true;

    this.listService.apiListIdGet({ id }).subscribe(
      (res) => {
        console.log(res);
        this.isLocked = res.locked ? res.locked : false;
        this.isLoading = false;
        this.form.patchValue({
          name: res.name,
          date: res.date,
          locked: res.locked
        });
        this.mapFamilies(res.families || []);
      },
      () => {
        this.isLoading = false;
        this.close();
      }
    );
  }

  loadFamilyData() {
    this.familyService
    .apiFamilyGet({
      ...this.tableData,
      filter: JSON.stringify({
        search: this.searchQueryControl.value,
      }),
    })
    .subscribe(
      (res) => {
        this.pageLoaded(res);
        this.isLoading = false;
        this.mapFamilies(res.results || []);
      },
      (err) => {
        this.isLoading = false;
      }
    );
    // this.isLoading = true;

    // this.familyService
    //   .apiFamilyGet({
    //     ...this.tableData,
    //     query: this.searchQueryControl.value,
    //     isFullSize: true,
    //     orderByKey: 'Representative'
    //   })
    //   .subscribe(
    //     (res) => {
    //       this.isLoading = false;
    //       this.mapFamilies(res.results || []);
    //     },
    //     (err) => {
    //       this.isLoading = false;
    //     }
    //   );
  }



  loadData() {
    if(!this.id) {
    this.isLoading = true;

    this.familyService
      .apiFamilyGet({
        ...this.tableData,
        filter: JSON.stringify({
          search: this.searchQueryControl.value,          
        }),
      })
      .subscribe(
        (res) => {
          this.pageLoaded(res);
          this.isLoading = false;
          this.data =
            res.results?.map((x) => ({
              id: x.id || 0,
              representative: x.representative || '',
              phone: x.phone || '',
              address: x.address || '',
              city: x.city || '',
              documents: x.documents || false,
              members: x.members || [],
              donations: x.donations || [],
              notes: x.notes || [],
              residence: x.residence || '',
              lastDonationOdjeca: x.donations
                ? x.donations.find((d: any) => d.categoryId === 2) || null
                : null,
            })) || [];
        },
        (err) => {
          this.isLoading = false;
        }
      );
    } else {
      this.loadList(this.id);
    }
  }
 
  mapFamilies(data: FamilyResponseDto[]) {
    this.data =
      data.map((x) => ({
        id: x.id || 0,
        representative: x.representative || '',
        phone: x.phone || '',
        address: x.address || '',
        city: x.city || '',
        documents: x.documents || false,
        members: x.members || [],
        donations: x.donations || [],
        lastDonationOdjeca: x.donations
        ? x.donations.find((d: any) => d.categoryId === 2) || null
        : null
      })).sort((a, b) => moment(a.lastDonationOdjeca?.donationDate).unix() - moment(b.lastDonationOdjeca?.donationDate).unix()) || [];
  }

  formatDate(d: Date) {
    if (!d)
    {
     return 'Nema donacija';
    }
    return moment(d).format('MM/DD/YYYY');
  }

  searchFamilies() {
    this.loadFamilyData();
  }

  close(saved?: boolean) {
    this.dialogRef.close({ saved });
  }

  createList() {
    if (!this.form.valid || this.setOfCheckedId.size === 0) {
      return;
    }

    this.isSaving = true;

    this.listService
      .apiListPost({
        listRequestDto: {
          name: this.form.value.name,
          families: Array.from(this.setOfCheckedId),
          date: this.form.value.date,
        },
      })
      .subscribe(
        (res) => {
          this.isSaving = false;
          this.close(true);
        },
        () => {
          this.isSaving = false;
        }
      );
  }


addNote(id: number)
{
  this.dialogService
  .open(SaveNoteDialogComponent, {
    size: 'sm',
    closeOnClickOutside: true,
    data: {
      familyId: id
    }
  })
  .afterClosed.subscribe((res) => {
    if (res?.saved) {
    }
  });
}

markReceivedDonation() {
  const listId = this.id;
  if (!this.form.valid || this.setOfCheckedId.size === 0) {
      return;
    }

  this.dialogService
    .open(ConfirmDialogComponent, {
      size: 'md',
    })
    .afterClosed.subscribe((res) => {
      if (res?.confirmed) {
        this.donationService.apiDonationDonationCentarPost
        ({
          donationListRequestDto: {
            families: Array.from(this.setOfCheckedId),
          },
        })
        .subscribe(
          (res) => {
            this.listService.apiListLockedIdGet({ id: listId }).subscribe(
              (res) => {
              },
              () => {
                this.isLoading = false;
                this.close();
              }
            );
            this.close(true);
          },
          () => {
            this.isSaving = false;
          }
        );
      }
    });

    // @todo call correct API

    //   this.isSaving = true;

    //   this.listService
    //     .apiListPost({
    //       listRequestDto: {
    //         name: this.form.value.name,
    //         families: Array.from(this.setOfCheckedId),
    //       },
    //     })
    //     .subscribe(
    //       (res) => {
    //         this.isSaving = false;
    //         this.close(true);
    //       },
    //       () => {
    //         this.isSaving = false;
    //       }
    //     );
  }

updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }

onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
  }
}
